// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GAEB import / export and the GAEB parts of the offer editor. Scoped to .gaeb-ui. */

.gaeb-ui .gaeb-ui__block {
  margin-block-start: 16px;
  width: 100%;
}

.gaeb-ui .gaeb-ui__center {
  display: flex;
  justify-content: center;
  padding-block: 24px;
}

.gaeb-ui .gaeb-ui__warnings {
  margin: 0;
  padding-inline-start: 18px;
  max-height: 160px;
  overflow-y: auto;
}

.gaeb-ui .gaeb-ui__check {
  margin-block-start: 8px;
}

.gaeb-ui.gaeb-tree,
.gaeb-ui .gaeb-tree {
  max-height: 45vh;
  overflow: auto;
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md);
  padding: 8px;
}

.gaeb-ui .gaeb-tree__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-block: 2px;
  overflow-wrap: anywhere;
}

.gaeb-ui .gaeb-tree__meta {
  font-size: 12px;
  color: var(--ds-text-muted);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.gaeb-ui .gaeb-tree__note {
  color: var(--ds-text-muted);
  overflow-wrap: anywhere;
}

.gaeb-ui .gaeb-tags {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
}

.gaeb-ui .gaeb-tags .ant-tag {
  margin-inline-end: 0;
}

.gaeb-ui.gaeb-headings {
  margin-block: 12px 4px;
  padding: 6px 10px;
  border-radius: var(--ds-radius-sm);
  background: var(--ds-surface-muted);
}

.gaeb-ui.gaeb-headings .gaeb-headings__row {
  overflow-wrap: anywhere;
}

.gaeb-ui.gaeb-item {
  margin-block-start: 8px;
}

.gaeb-ui.gaeb-item .gaeb-item__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.gaeb-ui.gaeb-item .gaeb-item__oz {
  font-variant-numeric: tabular-nums;
}

.gaeb-ui.gaeb-item .gaeb-item__text {
  margin-block: 4px 0;
  white-space: pre-line;
  font-size: 13px;
}

.gaeb-ui .gaeb-phases {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/gaeb/gaeb.css"],"names":[],"mappings":"AAAA,qFAAqF;;AAErF;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* GAEB import / export and the GAEB parts of the offer editor. Scoped to .gaeb-ui. */\n\n.gaeb-ui .gaeb-ui__block {\n  margin-block-start: 16px;\n  width: 100%;\n}\n\n.gaeb-ui .gaeb-ui__center {\n  display: flex;\n  justify-content: center;\n  padding-block: 24px;\n}\n\n.gaeb-ui .gaeb-ui__warnings {\n  margin: 0;\n  padding-inline-start: 18px;\n  max-height: 160px;\n  overflow-y: auto;\n}\n\n.gaeb-ui .gaeb-ui__check {\n  margin-block-start: 8px;\n}\n\n.gaeb-ui.gaeb-tree,\n.gaeb-ui .gaeb-tree {\n  max-height: 45vh;\n  overflow: auto;\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md);\n  padding: 8px;\n}\n\n.gaeb-ui .gaeb-tree__item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-block: 2px;\n  overflow-wrap: anywhere;\n}\n\n.gaeb-ui .gaeb-tree__meta {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.gaeb-ui .gaeb-tree__note {\n  color: var(--ds-text-muted);\n  overflow-wrap: anywhere;\n}\n\n.gaeb-ui .gaeb-tags {\n  display: inline-flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.gaeb-ui .gaeb-tags .ant-tag {\n  margin-inline-end: 0;\n}\n\n.gaeb-ui.gaeb-headings {\n  margin-block: 12px 4px;\n  padding: 6px 10px;\n  border-radius: var(--ds-radius-sm);\n  background: var(--ds-surface-muted);\n}\n\n.gaeb-ui.gaeb-headings .gaeb-headings__row {\n  overflow-wrap: anywhere;\n}\n\n.gaeb-ui.gaeb-item {\n  margin-block-start: 8px;\n}\n\n.gaeb-ui.gaeb-item .gaeb-item__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.gaeb-ui.gaeb-item .gaeb-item__oz {\n  font-variant-numeric: tabular-nums;\n}\n\n.gaeb-ui.gaeb-item .gaeb-item__text {\n  margin-block: 4px 0;\n  white-space: pre-line;\n  font-size: 13px;\n}\n\n.gaeb-ui .gaeb-phases {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
